const purchaseTemplate = {
  event: 'purchase', // A default GA4 event
  transaction_id: null, // The unique id for the txn, as a string
  currency: null, // The three-letter code for the txn currency, such as "USD"
  value: null, // The total amount (excl. taxes and shipping and including fees) in the txn currency
  shipping: null, // The total shipping charge, in the txn currency
  tax: null, // The total tax, in the txn currency
  visit_email: null, // The user’s unencrypted email address in base64
  visit_first_name: null, // The user’s unencrypted first name in base64
  visit_last_name: null, // The user’s unencrypted last name in base64
  value_aff: null, // Total amount (excl. taxes, shipping, and buyer/seller fees) in the txn currency
  coupon: null, // The discount code used in the purchase, if any, in base64
  item_list_qty: null, // The total amount of listings (NOT tickets) in the list (typically 1 unless cart is enabled)
  ticket_qty: null, // The total amount of tickets in the list
  items: null, // Usually just one entry, unless Cart is enabled for the store
  value_eur: null, // The total amount in EUR (excl. taxes and shipping and including fees)
  payment_method: null, // The payment method selected
  billing_country: null, // The tow-letter ISO code of the country, such as "ES"
};

export default purchaseTemplate;
